import React, { useEffect } from 'react';
import { useThree, useLoader } from '@react-three/fiber';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { KTX2Loader } from 'three/examples/jsm/loaders/KTX2Loader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';

const GLBPreview = ({ url }) => {
  const { gl, camera, scene } = useThree();
  camera.position.set(0, 6, 4.5);

  // Configure the loader
  const gltf = useLoader(GLTFLoader, url, (loader) => {
    const ktx2Loader = new KTX2Loader();
    ktx2Loader.setTranscoderPath('/vendor/basis/');
    ktx2Loader.detectSupport(gl);
    loader.setKTX2Loader(ktx2Loader);

    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath('/vendor/draco/');
    loader.setDRACOLoader(dracoLoader);
  });

  // Cleanup on url change
  useEffect(() => {
    // Add the model to the scene
    scene.add(gltf.scene);

    return () => {
      // Cleanup: Remove the model from the scene and dispose of resources
      scene.remove(gltf.scene);
      gltf.scene.traverse((object) => {
        if (object.isMesh) {
          object.geometry.dispose();
          if (object.material) {
            if (Array.isArray(object.material)) {
              object.material.forEach(mat => mat.dispose());
            } else {
              object.material.dispose();
            }
          }
        }
      });
    };
  }, [url, gltf, scene]);

  return <primitive object={gltf.scene} scale={[5, 5, 5]} position={[-1, 0, 0]} />;
};

export default GLBPreview;